import React, { useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import { createNewRatePriceForLecturerOperations } from '../operations/create-new-rate-price-for-lecturer-operations';
import { PaymentType } from '../../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';

interface AddNewRateTypeDialogModel {
  closeDialog: () => void;
}
export const AddNewRateTypeDialog: React.FC<AddNewRateTypeDialogModel> = ({
  closeDialog,
}) => {
  const [serviceType, setServiceType] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = async () => {
    await createNewRatePriceForLecturerOperations(
      serviceType,
      PaymentType.Discrete,
      closeDialog,
      setLoading,
    );
  };

  return (
    <div>
      <EditText title={'שם סוג התשלום'} onChange={setServiceType} />
      <div style={{ height: '8px' }} />
      <div
        style={{ height: '100%', display: 'flex', justifyContent: 'center' }}
      >
        <Button
          style={{ height: '30px' }}
          label={'אישור'}
          onClick={handleOnSubmit}
          loading={loading}
        />
      </div>
    </div>
  );
};
